import React from 'react';
import './../styles/Loader.css';
const Loader = ({ show }) => {
  if (!show) return null;

  return (
    <div className="overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
